import Vue from 'vue';

export const createPortal = (component, target, props = {}) => {
  let targetElement;
  if (typeof target === 'string') {
    targetElement = document.querySelector(target);
  } else if (target instanceof Element) {
    targetElement = target;
  }

  if (!targetElement) {
    console.error('[createPortal] Target element not found:', target);
    return null;
  }

  const componentInstance = new Vue({
    render: (h) => h(component, { props }),
  });

  const mountPoint = document.createElement('div');
  targetElement.appendChild(mountPoint);
  componentInstance.$mount(mountPoint);

  // Provide a way to destroy the portal instance
  const destroy = () => {
    if (componentInstance && componentInstance.$el && componentInstance.$el.parentNode) {
      componentInstance.$el.parentNode.removeChild(componentInstance.$el);
    }
    if (componentInstance) {
      componentInstance.$destroy();
    }
  };

  return {
    vm: componentInstance,
    destroy,
  };
};
